module.exports = __webpack_public_path__ + "img/service2.5ab652d2.jpg";